export const PAYU_POPUP_NAME = 'suitescanner_payu';

type PayUForm = {
    actionUrl: string;
    params: Api.Payment.Initiate.PayUParams;
};

export function openPayUPopup(): Window | null {
    if (typeof window === 'undefined') return null;
    const width = Math.min(1100, window.screen.availWidth);
    const height = Math.min(850, window.screen.availHeight);
    const left = Math.max(0, Math.round((window.screen.availWidth - width) / 2));
    const top = Math.max(0, Math.round((window.screen.availHeight - height) / 2));
    const popup = window.open('', PAYU_POPUP_NAME, `popup,width=${width},height=${height},left=${left},top=${top}`);
    if (popup) {
        try {
            popup.document.title = 'Connecting to PayU · SuiteScanner';
            popup.document.body.textContent = 'Preparing your secure PayU checkout…';
        }
        catch { /* A previously opened PayU window can be cross-origin. */ }
    }
    return popup;
}

export function submitPayUForm(payu: PayUForm, target: string): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = payu.actionUrl;
    form.target = target;
    form.style.display = 'none';
    for (const [key, value] of Object.entries(payu.params)) {
        if (value === undefined) continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
    }
    document.body.appendChild(form);
    try {
        form.submit();
    } finally {
        form.remove();
    }
}
